import * as Styled from 'components/PageWrappers/AdDetails/components/CarSummary/CarSummary.styled';
import {
  MileageOutlineIc,
  FuelOutlineIc,
  EngineOutlineIc,
  TransmissionOutlineIc,
  CalendarOutlineIc,
  PeopleOutlineIc,
  BatteryOutlineIc,
  CalendarCheckmarkOutlineIc,
} from '@dsch/dd-icons';
import type {
  CarSummaryProps,
  InfoTip,
  SummaryItemName,
} from 'components/PageWrappers/AdDetails/components/CarSummary/CarSummary.typed';
import { Link } from 'components/Toolkit/Button/Link';
import { MileageModal } from 'components/PageWrappers/AdDetails/components/CarSummary/MileageModal/MileageModal';
import { useState } from 'react';
import type { MileageIndicatorStates } from 'api/types/CarValuationApiTypes';
import InfoModal from 'components/PageWrappers/AdDetails/components/CarSummary/InfoModal/InfoModal';
import getConfig from 'next/config';
const {
  publicRuntimeConfig: { CAR_SUMMARY_INDICATOR_LINKS_ENABLED },
} = getConfig();

const CarSummary = (props: CarSummaryProps) => {
  const { vehicleSummary, mileageIndicator } = props;
  const [mileageInfoModalOpen, setMileageInfoModalOpen] = useState(false);
  const [infoModal, setInfoModal] = useState<InfoTip | null>(null);

  const openMileageInfoModal = () => {
    setMileageInfoModalOpen(true);
  };

  const closeMileageInfoModal = () => {
    setMileageInfoModalOpen(false);
  };

  const openInfoModal = (infoTip: InfoTip | null | undefined) => {
    infoTip && setInfoModal(infoTip);
  };

  const closeInfoModal = () => {
    setInfoModal(null);
  };

  const IconMap: { [K in SummaryItemName]: JSX.Element } = {
    mileage: <MileageOutlineIc />,
    fuelType: <FuelOutlineIc />,
    engine: <EngineOutlineIc />,
    transmission: <TransmissionOutlineIc />,
    NCTExpiry: <CalendarCheckmarkOutlineIc />,
    CRWExpiry: <CalendarCheckmarkOutlineIc />,
    owners: <PeopleOutlineIc />,
    batteryRange: <BatteryOutlineIc />,
    year: <CalendarOutlineIc />,
  };

  const mileageInfoLinkStates: { [K in MileageIndicatorStates]: string } = {
    Below: 'Below Avg.',
    Same: 'Same as Avg.',
    Above: 'Above Avg.',
  };

  return (
    <>
      <Styled.ListContainer>
        {vehicleSummary.values.map((item) => (
          <Styled.ListItem key={item.name} data-testid={'list-item'}>
            <Styled.ListItemNameContainer>
              <Styled.ListItemLeadingIcon>
                {IconMap[item.name] || <></>}
              </Styled.ListItemLeadingIcon>
              <Styled.ListItemName>
                {item.displayName || '---'}
              </Styled.ListItemName>
            </Styled.ListItemNameContainer>
            <Styled.ListItemValueContainer>
              <Styled.ListItemValue>
                {CAR_SUMMARY_INDICATOR_LINKS_ENABLED && item.infoTip ? (
                  <Link
                    ofType={'SECONDARY'}
                    underline
                    onClick={() => openInfoModal(item.infoTip)}
                  >
                    {item.displayValue || '---'}
                  </Link>
                ) : (
                  item.displayValue || '---'
                )}
              </Styled.ListItemValue>
              {CAR_SUMMARY_INDICATOR_LINKS_ENABLED &&
                mileageIndicator &&
                item.name == 'mileage' && (
                  <Link
                    ofType={'SECONDARY'}
                    underline
                    onClick={openMileageInfoModal}
                  >
                    {mileageInfoLinkStates[mileageIndicator.state]}
                  </Link>
                )}
            </Styled.ListItemValueContainer>
          </Styled.ListItem>
        ))}
      </Styled.ListContainer>
      {mileageIndicator && (
        <MileageModal
          isOpen={mileageInfoModalOpen}
          askToClose={closeMileageInfoModal}
          mileageIndicator={mileageIndicator}
        />
      )}
      {infoModal && (
        <InfoModal
          isOpen={!!infoModal}
          askToClose={closeInfoModal}
          testId={'info-modal'}
          {...infoModal}
        >
          <InfoModal.Text>{infoModal.description}</InfoModal.Text>
        </InfoModal>
      )}
    </>
  );
};

export { CarSummary };
